import React from 'react';
import {
  BUILDING_HEADCOUNT_SEATCOUNT_DEPARTMENTS,
  Growth,
} from 'spw-redux/modules/calculators/types';
import { TableCell, TableRow } from '@mui/material';
import { EmptyList } from 'spw-components/growth-calculator/styles';

import { useSelector } from 'react-redux';
import {
  selectCurrentScenario,
  selectIsEditingSavedScenario,
} from 'spw-redux/modules/calculators/selectors';
import GrowthEntries from 'spw-components/growth-calculator/growth-entries';

const Growths = ({
  testingIdPrefix,
  isRenderingForExport,
  isLinked,
}: {
  testingIdPrefix: string;
  isRenderingForExport?: boolean;
  isLinked?: boolean;
}) => {
  const currentScenario = useSelector(selectCurrentScenario);
  const isEditingSavedScenario = useSelector(selectIsEditingSavedScenario);

  const disabledInputs = isRenderingForExport
    ? false
    : currentScenario?.id && !isEditingSavedScenario;

  const { department } = currentScenario;
  const { calculatorType } = currentScenario;

  if (
    calculatorType === BUILDING_HEADCOUNT_SEATCOUNT_DEPARTMENTS &&
    !department?.id
  ) {
    return (
      <TableRow>
        <TableCell colSpan={14}>
          <EmptyList>No departments have been added</EmptyList>
        </TableCell>
      </TableRow>
    );
  }
  return (
    <>
      {currentScenario.growths.map((growth: Growth) => (
        <GrowthEntries
          key={`growth-entries-${growth.department?.id || 'total'}`}
          growth={growth}
          isLinked={isLinked}
          testingIdPrefix={testingIdPrefix}
          disabledInputs={disabledInputs}
        />
      ))}
    </>
  );
};

export default Growths;
